import React, { useEffect } from 'react';
import Separator from '../../shared/separator';
import LoggedOut from './logged-out';
import LoggedIn from './logged-in';
import { isAuthenticated } from '../../../membership/dal/data-provider';
import Links from './links';
import { useAppSelector, useAppDispatch, rootActions } from '../data/store';
import Preloader from '../../../../ui/svg/common/preloader';
import { IsAuthReferrer } from '../../../membership/enums/is-auth-referrer';

const DropPanel = () => {

    const dispatch = useAppDispatch();
    const isLoggedIn = useAppSelector(store => store.root.isLoggedIn);
    const userName = useAppSelector(store => store.root.userName);
    const showNewUserPopup = useAppSelector(store => store.root.showNewUserPopup);
    const isLoading = useAppSelector(store => store.root.isLoading);

    useEffect(() => {
        (async () => {
            dispatch(rootActions.main({
                isLoading: true,
            }));

            const response = await isAuthenticated(IsAuthReferrer.SiteHeader);

            if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData){
                dispatch(rootActions.main({
                    isLoggedIn: false,
                    userName: '',
                    isLoading: false,
                }));
                return;
            }

            const isUserAuthenticated: boolean = response.data.relatedData.isUserAuthenticated;
            if(isUserAuthenticated){
                dispatch(rootActions.main({
                    isLoggedIn: isUserAuthenticated,
                    userName: response.data.relatedData.userName ?? '',
                    isLoading: false,
                }));
            }
            else{
                dispatch(rootActions.main({
                    isLoggedIn: false,
                    userName: '',
                    isLoading: false,
                }));
            }
        })();
    }, [dispatch]);

    return (
        <div className={`waves-header-account-drop absolute right-0 top-full bg-white text-gray-500 shadow-md rounded px-4 py-2 text-tiny border border-gray-100 ${ isLoading ? 'flex flex-col h-full' : '' }`} style={{
            minHeight: showNewUserPopup ? 'auto' : '400px',
        }}>

            {
                isLoading &&
                <div className="flex justify-center items-center w-full h-full">
                    <Preloader width="25px" height="25px" color="#4f4f4f" />
                </div>
            }

            {
                !isLoading &&
                <>
                    { !isLoggedIn && <LoggedOut /> }
                    { isLoggedIn && <LoggedIn userName={ userName } /> }

                    {
                        !showNewUserPopup &&
                        <>
                            <Separator margin="my-2" />
                            <Links />
                        </>
                    }
                </>
            }
        </div>
    )
};

export default DropPanel;